import React from 'react';

export const AdultsOnlyUndressingShowerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.4601 33.8C21.4431 33.8 22.2401 33.0031 22.2401 32.02C22.2401 31.0369 21.4431 30.24 20.4601 30.24C19.477 30.24 18.6801 31.0369 18.6801 32.02C18.6801 33.0031 19.477 33.8 20.4601 33.8Z"
        fill="#1C74BB"
      />
      <path
        d="M16.68 37.4599C17.6631 37.4599 18.46 36.663 18.46 35.6799C18.46 34.6968 17.6631 33.8999 16.68 33.8999C15.697 33.8999 14.9 34.6968 14.9 35.6799C14.9 36.663 15.697 37.4599 16.68 37.4599Z"
        fill="#1C74BB"
      />
      <path
        d="M12.98 41.06C13.963 41.06 14.76 40.2631 14.76 39.28C14.76 38.2969 13.963 37.5 12.98 37.5C11.9969 37.5 11.2 38.2969 11.2 39.28C11.2 40.2631 11.9969 41.06 12.98 41.06Z"
        fill="#1C74BB"
      />
      <path
        d="M15.78 29.1C16.7631 29.1 17.56 28.3031 17.56 27.32C17.56 26.337 16.7631 25.54 15.78 25.54C14.7969 25.54 14 26.337 14 27.32C14 28.3031 14.7969 29.1 15.78 29.1Z"
        fill="#1C74BB"
      />
      <path
        d="M10.26 30.8801C11.243 30.8801 12.04 30.0831 12.04 29.1001C12.04 28.117 11.243 27.3201 10.26 27.3201C9.27691 27.3201 8.47998 28.117 8.47998 29.1001C8.47998 30.0831 9.27691 30.8801 10.26 30.8801Z"
        fill="#1C74BB"
      />
      <path
        d="M4.75998 32.8601C5.74305 32.8601 6.53998 32.0631 6.53998 31.08C6.53998 30.097 5.74305 29.3 4.75998 29.3C3.77691 29.3 2.97998 30.097 2.97998 31.08C2.97998 32.0631 3.77691 32.8601 4.75998 32.8601Z"
        fill="#1C74BB"
      />
      <path
        d="M25.12 38.4399C26.103 38.4399 26.9 37.6429 26.9 36.6599C26.9 35.6768 26.103 34.8799 25.12 34.8799C24.1369 34.8799 23.34 35.6768 23.34 36.6599C23.34 37.6429 24.1369 38.4399 25.12 38.4399Z"
        fill="#1C74BB"
      />
      <path
        d="M23.16 43.9001C24.1431 43.9001 24.94 43.1032 24.94 42.1201C24.94 41.137 24.1431 40.3401 23.16 40.3401C22.1769 40.3401 21.38 41.137 21.38 42.1201C21.38 43.1032 22.1769 43.9001 23.16 43.9001Z"
        fill="#1C74BB"
      />
      <path
        d="M21.36 49.4599C22.343 49.4599 23.14 48.663 23.14 47.6799C23.14 46.6968 22.343 45.8999 21.36 45.8999C20.3769 45.8999 19.58 46.6968 19.58 47.6799C19.58 48.663 20.3769 49.4599 21.36 49.4599Z"
        fill="#1C74BB"
      />
      <path
        d="M31.9 35.4799C26.58 30.78 21.58 25.84 16.98 20.58C16.06 19.54 16.14 17.94 17.12 16.96L18.38 15.7L36.8 34.0999L35.56 35.34C34.58 36.32 32.98 36.3799 31.94 35.4599L31.9 35.4799Z"
        fill="#1C74BB"
      />
      <path
        d="M56.84 54.98H54.2C53.28 54.98 52.54 54.24 52.54 53.32V30.26C52.54 24.92 50.02 20.16 46.14 18.1C44.2 17.06 41.12 16.36 37.52 18.8C35.8 19.98 35.38 20.44 35.36 20.46C35.54 20.26 35.98 19.48 35.78 18.46L32.9 18.98L31.44 21.68L29.86 19.14C29.76 17.22 31.16 15.92 34.14 13.9C38.78 10.74 44.18 10.36 48.9 12.86C54.72 15.94 58.48 22.78 58.48 30.3V53.36C58.48 54.28 57.74 55.02 56.82 55.02L56.84 54.98Z"
        fill="#7D7D7D"
      />
      <path
        d="M30.7775 14.3594L38.1353 21.7095C40.4416 24.0135 40.4436 27.7753 38.1397 30.0816L37.3198 30.9023L21.5997 15.1986L22.4195 14.378C24.7235 12.0716 28.4853 12.0696 30.7917 14.3736L30.7775 14.3594Z"
        fill="#545454"
      />
      <path
        d="M32.7938 13.2435L39.2318 19.6748C39.7412 20.1836 39.7416 21.0039 39.2328 21.5133L38.1868 22.5603L29.9235 14.3057L30.9694 13.2586C31.4783 12.7492 32.2985 12.7488 32.8079 13.2576L32.7938 13.2435Z"
        fill="#2B2B2B"
      />
    </svg>
  );
};
